"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areas = void 0;
var areafeesUrl = '/areafees';
exports.areas = function (axios) {
    return {
        getAreafees: function (getAreafeesRequest) {
            return axios.get(areafeesUrl, getAreafeesRequest);
        },
        postAreafees: function (postAreafeesRequest) {
            return axios.post(areafeesUrl, postAreafeesRequest.data);
        },
        deleteAreafeesBulk: function (deleteAreafeesBulkRequest) {
            return axios.delete(areafeesUrl + '/bulk', deleteAreafeesBulkRequest);
        },
        getAreafeesByAreaFeeNo: function (getAreafeesByAreaFeeNoRequest) {
            return axios.get(areafeesUrl + '/' + getAreafeesByAreaFeeNoRequest.params.areaFeeNo, getAreafeesByAreaFeeNoRequest);
        },
        putAreafeesByAreaFeeNo: function (putAreafeesByAreaFeeNoRequest) {
            return axios.put(areafeesUrl + '/' + putAreafeesByAreaFeeNoRequest.params.areaFeeNo, putAreafeesByAreaFeeNoRequest.data);
        },
        getAreas: function (getAreasRequest) {
            return axios.get('/areas', getAreasRequest);
        },
        postAreas: function (request) {
            return axios.post('/areas', request.data);
        },
        deleteAreasByAreaNo: function (request) {
            return axios.delete("/areas/" + request.params.areaNo, request);
        },
        deleteAreasBulk: function (request) {
            return axios.delete('/areas/bulk', request);
        },
        getAreafeesCheckUsing: function (request) {
            var url = "/areafees/" + request.params.no + "/check-using";
            return axios.get(url);
        }
    };
};
